export default __webpack_public_path__ + "static/media/etherscan-logo.2c04d338.svg";